import CircleIcon from './circle-icon';
import Default from './default';

const Button = {
  CircleIcon, Default,
};

export default Button;
